import React from 'react';

const PostIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  return <img src="/images/post.svg" alt="Post" style={{ ...style }} />;
};

export default PostIcon;
